/* esm.sh - applesauce-core@5.2.0/helpers/pipeline */
export * from "/*applesauce-core@5.2.0/esnext/helpers/pipeline.mjs";
